var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"1000px"}},[_c('h2',[_vm._v("Iframe Embed Test")]),_c('br'),_c('iframe',{ref:"ifrm",staticStyle:{"width":"100%","height":"100%","border":"1px solid #eee"},attrs:{"src":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }